<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right">

      <div class="teacher-kq-tab-bar">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="">
          </el-tab-pane>
          <el-tab-pane v-for="t in liveTypeTabs" :key="t.LiveTypeId" :label="t.LiveTypeName" :name="t.LiveTypeId">
          </el-tab-pane>
        </el-tabs>
      </div>

      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        height="100%" style="width: 100%" class="custom-tbl">
        <el-table-column type="selection" width="50"></el-table-column>
        <!-- <el-table-column type="index" width="80"></el-table-column> -->
        <el-table-column prop="UserName" label="姓名" min-width="90"></el-table-column>
        <el-table-column prop="DeptName" label="部门" min-width="120"></el-table-column>
        <el-table-column prop="KaoqinDate" label="考勤日期" min-width="120"></el-table-column>
        <el-table-column prop="LateCount" label="迟到数" min-width="80"></el-table-column>
        <el-table-column prop="EquitCount" label="早退数" min-width="80"></el-table-column>
        <el-table-column prop="NormalCount" label="正常数" min-width="80"></el-table-column>
        <el-table-column prop="LeaveCount" label="请假数" min-width="80"></el-table-column>
        <el-table-column prop="MissCount" label="缺勤数" min-width="80"></el-table-column>

        <el-table-column fixed="right" label="操作" width="80">
          <template slot-scope="scope">
            <el-button @click="showuserKqtData(scope.row)" type="text">查看</el-button>
          </template>
        </el-table-column>

      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right"></el-pagination>
      </el-col>

      <el-dialog  title="考勤记录" :visible.sync="userKqtDataDialogVisible" width="70%" center
        top="5vh" @close="userKqtDataHandleClose">

        <!--列表：固定 height，末页数据少时表体高度不变。最后更新：2026-08-31 -->
        <el-table :data="userKqtDataPageList" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
          ref="userKqtTable" style="width: 100%" class="custom-tbl" max-height="480">
          <el-table-column type="selection" width="50"></el-table-column>
          <!-- <el-table-column type="index" width="80"></el-table-column> -->
          <el-table-column prop="UserName" label="姓名" width></el-table-column>
          <el-table-column prop="KaoqinDate" label="考勤日期" width></el-table-column>
          <el-table-column prop="RegTime1" label="第1次" width>
            <template slot-scope="scope">
              <span :style="{ color: getStatusColor(scope.row.RegStatus1) }">{{ scope.row.RegTime1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="RegTime2" label="第2次" width>
            <template slot-scope="scope">
              <span :style="{ color: getStatusColor(scope.row.RegStatus2) }">{{ scope.row.RegTime2 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="RegTime3" label="第3次" width>
            <template slot-scope="scope">
              <span :style="{ color: getStatusColor(scope.row.RegStatus3) }">{{ scope.row.RegTime3 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="RegTime4" label="第4次" width>
            <template slot-scope="scope">
              <span :style="{ color: getStatusColor(scope.row.RegStatus4) }">{{ scope.row.RegTime4 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="RegTime5" label="第5次" width>
            <template slot-scope="scope">
              <span :style="{ color: getStatusColor(scope.row.RegStatus5) }">{{ scope.row.RegTime5 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="RegTime6" label="第6次" width>
            <template slot-scope="scope">
              <span :style="{ color: getStatusColor(scope.row.RegStatus6) }">{{ scope.row.RegTime6 }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="DailyKaoqinStatus" label="状态" width></el-table-column>
          <!-- <el-table-column prop="DailyWorkSeconds" label="学时" width></el-table-column> -->
          <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <el-button @click="showHistory(scope.row)" type="text">查看</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!--工具条-->
        <div style="text-align: right; padding-top: 5px;">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleUserKqtDataPageChange" :page-size="userKqtDataPageSize"
            :total="userKqtData.length" :current-page.sync="userKqtDataPage" style="display: inline-block;"></el-pagination>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="userKqtDataDialogVisible = false">取 消</el-button>
        </div>

      </el-dialog>

      <el-dialog title="考勤详情记录" :visible.sync="dialogVisible" width="40%" center @close="historyDataHandleClose">
        <el-table :data="historyData" class="custom-tbl" style="width: 100%">
          <el-table-column property="Time" label="时间"></el-table-column>
          <el-table-column property="KqTerminalId" label="考勤终端"></el-table-column>
          <el-table-column property="ProcessResult" label="处理情况"></el-table-column>
        </el-table>

        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleHistoryDataChange" :page-size="10"
            :total="historyDataTotal" style="float: right"></el-pagination>
        </el-col>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>

    </section>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getUserMonthDetail, getUserMonthRecords, getKqtGatherRawHistoryListPage, exportUserMonthDetail } from '../../api/modules/attendance';
import { fetchStudentLiveTypesByDeptId } from '../../utils/studentLiveType';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      activeName: "",
      liveTypeTabs: [],
      filters: {
      },
      searchList: [
        {
          label: '姓名',
          key: 'name',
        },
        {
          label: '日期',
          key: 'date',
          type: 'month'
        },
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: "",
      dialogVisible: false,
      currentDate: "",
      historyData: [],
      historyDataTitle: "",
      historyDataTotal: 0,
      historyDataPage: 1,
      historyUserId: 0,

      userKqtData: [],
      userKqtDataTitle: "",
      userKqtDataDialogVisible: false,
      userKqtDate: "",
      userKqtDataPage: 1, // 当前页码
      userKqtDataPageSize: 10 // 每页大小
    };
  },
  computed: {
    // 考勤记录弹窗前端分页计算属性
    userKqtDataPageList() {
      const start = (this.userKqtDataPage - 1) * this.userKqtDataPageSize;
      const end = this.userKqtDataPage * this.userKqtDataPageSize;
      return this.userKqtData.slice(start, end);
    }
  },
  methods: {
    handleClick(tab, event) {
      this.page = 1;
      this.handleQuery();
    },
    getStatusColor(status) {
      if (status != "normal") {
        return 'red';
      }
      return '';
    },
    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.loadLiveTypeTabs();
      this.handleQuery();
    },
    async loadLiveTypeTabs() {
      this.liveTypeTabs = await fetchStudentLiveTypesByDeptId(this.DepartmentId);
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.currentDate = item.search.date || "";
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let _this = this;
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        liveTypeId: this.activeName,
        ...this.filters,
      };
      this.listLoading = true;
      //NProgress.start();
      getUserMonthDetail(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },

    handleHistoryDataChange(val) {
      this.historyDataPage = val;
      this.handleHistoryDataQuery();
    },

    handleHistoryDataQuery() {
      let para = {
        page: this.historyDataPage,
        departmentId: this.DepartmentId,
        date: this.userKqtDate,
        userAccountUid: this.historyUserId
      };
      getKqtGatherRawHistoryListPage(para).then((res) => {
        this.historyDataTotal = res.data.response.dataCount;
        this.historyData = res.data.response.data;
        this.$nextTick(() => { this.dialogVisible = true; })

      });
    },

    showHistory(row) {
      this.historyUserId = row.UserId;
      this.userKqtDate = row.KaoqinDate;
      this.handleHistoryDataQuery();
    },

    historyDataHandleClose() {
      this.historyData = [];
      this.historyDataTotal = 0;
      this.historyDataPage = 1;
    },

    showuserKqtData(row) {
      this.historyUserId = row.UserId;
      this.userKqtDataQuery(row.KaoqinDate);
    },

    userKqtDataQuery(date) {
      let para = {
        departmentId: this.DepartmentId,
        userId: this.historyUserId,
        date: date
      };
      this.userKqtDataPage = 1; // 重置页码
      getUserMonthRecords(para).then((res) => {
        this.userKqtData = res.data.response;
        this.$nextTick(() => { this.userKqtDataDialogVisible = true; })

      });
    },

    userKqtDataHandleClose() {
      this.userKqtData = [];
      this.userKqtDataPage = 1; // 重置页码
    },

    // 考勤记录弹窗分页切换事件
    handleUserKqtDataPageChange(val) {
      this.userKqtDataPage = val;
    },
    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          liveTypeId: this.activeName,
          ...this.filters,
        };

        var fileName = "个人考勤汇总";
        const response = await exportUserMonthDetail(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        // 处理导出数据        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

</style>
